import * as React from "react";

import { ILesson, ICurrency } from "./types";
import PricePrimary from "../Shared/PricePrimary";
import { getImage } from "../utils/pathHelper";
import { minPrice } from "../utils/priceHelper";
import clockImage from "./images/line_icon/clock.svg";
import styles from "./styles/index.module.scss";

type ILessonItem = {
	lesson: ILesson;
	localCurrency: ICurrency;
};

const LessonItem: React.FC<ILessonItem> = ({ lesson, localCurrency }) => {
	const { snowItemId, name, priceTable, merchantId } = lesson;
	const price = minPrice({ priceTable, selectedDateList: [] });
	let priceToDisplay = null;
	// グループ料金 > 大人料金 > 子供料金の順で優先する
	if (price?.childPrice && price.childFullPrice) {
		priceToDisplay = [price.childPrice, price.childFullPrice];
	}
	if (price?.adultPrice && price.adultFullPrice) {
		priceToDisplay = [price.adultPrice, price.adultFullPrice];
	}
	if (price?.groupPrice && price.groupFullPrice) {
		priceToDisplay = [price.groupPrice, price.groupFullPrice];
	}

	return (
		<a
			className={styles.lessonSchoolItem}
			href={`/snow/items/${snowItemId}`}
			{...(merchantId ? { "data-snow-item-merchant": merchantId } : {})}
		>
			<div className={styles.leftColumn}>
				<div className={styles.image}>
					<img src={getImage(clockImage)} />
					<p>{lesson.requiredMinutes} min</p>
				</div>
				<div className={styles.content}>
					<p className={styles.resortName}>{lesson.resorts[0].resortName}</p>
					<p>{name}</p>
				</div>
			</div>
			<div className={styles.rightColumn}>
				{priceToDisplay && (
					<PricePrimary
						price={priceToDisplay[0]}
						fullPrice={priceToDisplay[1]}
						showDiscount
						localCurrency={localCurrency}
						showJPY={true}
						wavyLine={true}
					/>
				)}
			</div>
		</a>
	);
};

export default LessonItem;
